import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/types';
import { requestAPI } from '../services/request';
import { API } from '../services/api';
import { ResponseStatus } from '../../constants/constant';
import { store } from '../store';
import { hideLoading, showLoading } from '../actions';

function* getUserRankInfo(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.GET_USER_RANK_INFO,
      API.GET,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.USER_RANK_INFO_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({ type: types.USER_RANK_INFO_FAILED, error: response });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.USER_RANK_INFO_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* requestUpRank(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.REQUEST_UP_RANK,
      API.POST,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.UP_RANK_SUCCEEDED
      });
    } else {
      yield put({
        type: types.UP_RANK_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.UP_RANK_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* requestRemainRank(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.REQUEST_REMAIN_RANK,
      API.POST,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.REMAIN_RANK_SUCCEEDED
      });
    } else {
      yield put({
        type: types.REMAIN_RANK_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.REMAIN_RANK_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* approvedOrRejectedRank(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.APPROVEED_OR_REJECTED_PROMOTE_RANK,
      API.POST,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.APPROVEED_OR_REJECTED_PROMOTE_RANK_SUCCEEDED
      });
    } else {
      yield put({
        type: types.APPROVEED_OR_REJECTED_PROMOTE_RANK_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.APPROVEED_OR_REJECTED_PROMOTE_RANK_FAILED, error });
  }
  store.dispatch(hideLoading());
}

export function* watchGetUserRankInfo() {
  yield takeLatest(types.USER_RANK_INFO_REQUESTED, getUserRankInfo);
}

export function* watchRequestUpRank() {
  yield takeLatest(
    types.UP_RANK_REQUESTED,
    requestUpRank
  );
}

export function* watchRequestRemainRank() {
  yield takeLatest(
    types.REMAIN_RANK_REQUESTED,
    requestRemainRank
  );
}

export function* watchApprovedOrRejectedRank() {
  yield takeLatest(
    types.APPROVEED_OR_REJECTED_PROMOTE_RANK_REQUESTED,
    approvedOrRejectedRank
  );
}